import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useSystemRunQuery } from '../../../hooks/useSystemQueries';
import { RowsTable } from './RowsTable';
import { toRows } from './toRows';

/** What a migration run changed: its options, result and the recorded rows. */
export const RunDetailsDialog = ({ runId, onClose }: { runId: string | null; onClose: () => void }) => {
  const { t } = useTranslation();
  const run = useSystemRunQuery(runId);
  const data = run.data;
  const rows = toRows(data?.undo);
  return (
    <Dialog open={Boolean(runId)} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{t('dashboard.system.history.details')}</DialogTitle>
      <DialogContent>
        {data && (
          <>
            <dl className="system-details">
              {data.options && Object.keys(data.options).length > 0 && (
                <>
                  <dt>{t('dashboard.system.history.options')}</dt>
                  <dd>{JSON.stringify(data.options)}</dd>
                </>
              )}
              <dt>{t('dashboard.system.history.result')}</dt>
              <dd>{JSON.stringify(data.summary ?? {})}</dd>
              {data.revertSummary && (
                <>
                  <dt>{t('dashboard.system.history.revertResult')}</dt>
                  <dd>{JSON.stringify(data.revertSummary)}</dd>
                </>
              )}
            </dl>
            <p className="team-muted">{t('dashboard.system.history.changed', { count: rows.length })}</p>
            <RowsTable rows={rows} />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
